export function useLogout() {
  const { public: env } = useRuntimeConfig()

  const { origin } = useRequestURL()

  return async function logout() {
    return navigateTo(
      {
        path: `${env.urls.core.external}/lokus/am/frontend/logout`,
        query: {
          redirect: origin,
        },
      },
      {
        external: true,
      },
    )
  }
}
